jQuery(document).foundation();

jQuery(document).ready(function () {
  jQuery("#selectCountry").select2();
  // jQuery(".select-country").select2();
  jQuery("#resourceType").select2();
  jQuery("#hashTag").select2();
  jQuery("#languageResource").select2();
  jQuery("#yearIssued").select2();
});

jQuery(document).ready(function ($) {
  // Configure/customize these variables.
  var showChar = 140; // How many characters are shown by default
  var ellipsestext = "...";
  var moretext = "READ MORE v";
  var lesstext = "READ LESS ^";

  $(".single-resource-excerpt").each(function () {
    var content = $(this).html();

    if (content.length > showChar) {
      var c = content.substr(0, showChar);
      var h = content.substr(showChar, content.length - showChar);

      var html =
        c +
        '<span class="moreellipses">' +
        ellipsestext +
        '&nbsp;</span><span class="morecontent"><span>' +
        h +
        '</span>&nbsp;&nbsp;<a href="" class="morelink">' +
        moretext +
        "</a></span>";

      $(this).html(html);
    }
  });

  $(".morelink").click(function () {
    if ($(this).hasClass("less")) {
      $(this).removeClass("less");
      $(this).html(moretext);
    } else {
      $(this).addClass("less");
      $(this).html(lesstext);
    }
    $(this).parent().prev().toggle();
    $(this).prev().toggle();
    return false;
  });

  $(".search-updates-form .select-post-type").change(function () {
    var selected_update = $(".select-post-type option:selected").text();
    if (selected_update == "Stories") {
      $(".stories-filter-container").show();
    } else {
      $(".stories-filter-container").hide();
    }

    if (selected_update == "News") {
      $(".news-filter-container").show();
    } else {
      $(".news-filter-container").hide();
    }
  });

  $("#flt1_countryTracker").html(
    '<option value="">Clear</option><option value="green">green</option><option value="yellow">yellow</option><option value="orange">orange</option><option value="red">red</option><option value="grey">grey</option>'
  );
  $("#flt2_countryTracker").html(
    '<option value="">Clear</option><option value="green">green</option><option value="yellow">yellow</option><option value="orange">orange</option><option value="red">red</option><option value="grey">grey</option>'
  );
  $("#flt3_countryTracker").html(
    '<option value="">Clear</option><option value="green">green</option><option value="yellow">yellow</option><option value="orange">orange</option><option value="red">red</option><option value="grey">grey</option>'
  );
  $("#flt4_countryTracker").html(
    '<option value="">Clear</option><option value="green">green</option><option value="yellow">yellow</option><option value="orange">orange</option><option value="red">red</option><option value="grey">grey</option>'
  );
  $("#flt5_countryTracker").html(
    '<option value="">Clear</option><option value="green">green</option><option value="yellow">yellow</option><option value="orange">orange</option><option value="red">red</option><option value="grey">grey</option>'
  );
  $("#flt6_countryTracker").html(
    '<option value="">Clear</option><option value="green">green</option><option value="yellow">yellow</option><option value="orange">orange</option><option value="red">red</option><option value="grey">grey</option>'
  );
  $("#flt7_countryTracker").html(
    '<option value="">Clear</option><option value="green">green</option><option value="yellow">yellow</option><option value="orange">orange</option><option value="red">red</option><option value="grey">grey</option>'
  );

  $(".aptf-tweets-wrapper").slick({
    autoplay: true,
    autoplaySpeed: 3000,
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});

document
  .querySelectorAll(
    "img.svg-icon, .footer-social img.image, .mobile-search-btn img"
  )
  .forEach(function (img) {
    var imgID = img.id;
    var imgClass = img.className;
    var imgURL = img.src;

    fetch(imgURL)
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var parser = new DOMParser();
        var xmlDoc = parser.parseFromString(text, "text/xml");

        // Get the SVG tag, ignore the rest
        var svg = xmlDoc.getElementsByTagName("svg")[0];

        // Add replaced image's ID to the new SVG
        if (typeof imgID !== "undefined") {
          svg.setAttribute("id", imgID);
        }
        // Add replaced image's classes to the new SVG
        if (typeof imgClass !== "undefined") {
          svg.setAttribute("class", imgClass + " replaced-svg");
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        svg.removeAttribute("xmlns:a");

        // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
        if (
          !svg.getAttribute("viewBox") &&
          svg.getAttribute("height") &&
          svg.getAttribute("width")
        ) {
          svg.setAttribute(
            "viewBox",
            "0 0 " +
              svg.getAttribute("height") +
              " " +
              svg.getAttribute("width")
          );
        }

        // Replace image with new SVG
        img.parentNode.replaceChild(svg, img);
      });
  });

jQuery("#lightgallery").nanogallery2();

// document.getElementById('hamburgerIcon').onclick = function changeContent() {

//     const pizza = document.querySelector('.hamburger');
//     pizza.classList.toggle('is-active');

//  }

// var menu = document.querySelector('.hamburger') // Using a class instead, see note below.
// menu.classList.toggle('is-active');

// var checkbox = document.querySelector('input[name=mode]');

// var body = document.querySelector('body');

// checkbox.addEventListener('change', function() {
//     if(this.checked) {
//         trans()
//         body.setAttribute('data-theme', 'dark')
//     } else {
//         trans()
//         body.setAttribute('data-theme', 'light')
//     }
// })

// let trans = () => {
//     document.documentElement.classList.add('transition');
//     window.setTimeout(() => {
//         document.documentElement.classList.remove('transition');
//     }, 1000)
// }
